export const GET_ALL_INVOICES = 'GET_ALL_INVOICES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SINGLE_INVOICE = 'GET_SINGLE_INVOICE'
